"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    box: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    input: {
      marginLeft: 4,
      marginRight: 4,
      width: 24,
      height: 24,
      border: 0,
      fontSize: 16,
      fontWeight: 700,
      fontFamily: "Vodafone",
      backgroundColor: "transparent",
      "& input": {
        textAlign: "center"
      }
    },
    button: {
      width: 24,
      height: 24,
      borderRadius: 24,
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        stroke: theme.palette.text.primary,
        width: 18,
        height: 18,
        transition: theme.transitions.create(["stroke"], {
          duration: theme.transitions.duration.standard
        })
      },
      "&:hover": {
        backgroundColor: theme.palette.text.primary,
        color: theme.palette.grey[200],
        "& .MuiSvgIcon-root": {
          stroke: theme.palette.grey[200]
        }
      },
      "&:disabled": {
        color: theme.palette.common.white,
        "& .MuiSvgIcon-root": {
          stroke: theme.palette.common.white
        }
      },
      transition: theme.transitions.create(["background-color"], {
        duration: theme.transitions.duration.standard
      })
    }
  };
});
/**
 * ** The quantity picker gives the ability to the user to select value in a specific range  **
 *
 * It has 2 limits: Min, Max
 */

var PickerQuantity = function PickerQuantity(_ref) {
  var value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      onClickInc = _ref.onClickInc,
      onClickDec = _ref.onClickDec;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: styles.box
  }, /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick() {
      return onClickDec();
    },
    className: styles.button,
    disabled: value <= min
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: "ic_minus__or__less"
  })), /*#__PURE__*/_react.default.createElement(_core.InputBase, {
    className: styles.input,
    value: value,
    min: min,
    max: max
  }), /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick() {
      return onClickInc();
    },
    className: styles.button,
    disabled: value >= max
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: "ic_add__or__plus"
  })));
};

PickerQuantity.propTypes = {
  /** The value of the picker */
  value: _propTypes.default.number.isRequired,

  /** Action to call to increase the value */
  onClickInc: _propTypes.default.func.isRequired,

  /** Action to call to decrease the value */
  onClickDec: _propTypes.default.func.isRequired,

  /** The minimum limit value */
  min: _propTypes.default.number,

  /** The maximum limit value */
  max: _propTypes.default.number
};
PickerQuantity.defaultProps = {
  min: 1,
  max: 10
};
var _default = PickerQuantity;
exports.default = _default;